import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PERMISSION_COST } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import CostsOverviewForm from '../../components/OperationCosts/OperatingCostsOverView/CostsOverviewForm';

// Optional search params (deep-link / row-action filters); never fail validation.
const costsEditSearchSchema = z.object({
  customerId: z.coerce.number().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/costs/edit/$id')({
  validateSearch: costsEditSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_COST, ['read'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.detail',
        suffix: 'menu.costs',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  const { id } = Route.useParams();
  const { customerId } = Route.useSearch();

  return <CostsOverviewForm selectedId={Number(id)} customerIds={customerId ?? null} />;
}
